import classNames from "classnames";
import React from "react";
import {
  MdNavigateNext,
  MdNavigateBefore,
  MdSkipPrevious,
  MdSkipNext,
} from "react-icons/md";

interface PaginationProps {
  page: number;
  totalPage: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  onPageChange: (page: number) => void;
  onTakeChange: (take: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  totalPage,
  hasPrevPage,
  hasNextPage,
  onPageChange,
  onTakeChange,
}) => {
  return (
    <div>
      <div className="mb-2 flex justify-center p-5 md:justify-between">
        <div className="hidden gap-2 md:flex">
          <span className="text-small flex items-center">Show</span>
          <select
            onChange={(e) => onTakeChange(parseInt(e.target.value))}
            className="text-small"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
          <span className="text-small flex items-center">Per Page</span>
        </div>
        <div className="flex gap-2">
          <button
            disabled={!hasPrevPage}
            onClick={() => onPageChange(1)}
            className={classNames(
              "btn-outline !px-1.5 !py-1 !text-xl",
              !hasPrevPage && "disabled"
            )}
          >
            <MdSkipPrevious />
          </button>
          <button
            disabled={!hasPrevPage}
            onClick={() => onPageChange(page - 1)}
            className={classNames(
              "btn-outline !px-1.5 !py-1 !text-xl",
              !hasPrevPage && "disabled"
            )}
          >
            <MdNavigateBefore />
          </button>
          <span className="text-small flex items-center px-2">
            Page {page} of {totalPage}
          </span>
          <button
            disabled={!hasNextPage}
            onClick={() => onPageChange(page + 1)}
            className={classNames(
              "btn-outline !px-1.5 !py-1 !text-xl",
              !hasNextPage && "disabled"
            )}
          >
            <MdNavigateNext />
          </button>
          <button
            disabled={!hasNextPage}
            onClick={() => onPageChange(totalPage)}
            className={classNames(
              "btn-outline !px-1.5 !py-1 !text-xl",
              !hasNextPage && "disabled"
            )}
          >
            <MdSkipNext />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
